/* Publish by EComposer at 2026-09-30 20:26:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2q964gkzbfq"]=  window.__ectimmers["ecom-2q964gkzbfq"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2q964gkzbfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2q964gkzbfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2gnjhxiwll6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2gnjhxiwll6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orvvvszpulm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orvvvszpulm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xh2i9ppuiu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xh2i9ppuiu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrszei37apf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrszei37apf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0kp867cyuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0kp867cyuo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yilpdwcgepm"]=  window.__ectimmers["ecom-yilpdwcgepm"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-yilpdwcgepm"]["6xiro7t4v"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-yilpdwcgepm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yilpdwcgepm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsg7s0f68ya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsg7s0f68ya', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bb7vn3ot4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bb7vn3ot4h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bn3vvo8x1bs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bn3vvo8x1bs', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cum2hmg2tn"]=  window.__ectimmers["ecom-cum2hmg2tn"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-cum2hmg2tn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cum2hmg2tn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28t4ft8uv9x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28t4ft8uv9x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8kq5sro37uw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8kq5sro37uw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tj0cedo489p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tj0cedo489p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-649t93d8snh"]=  window.__ectimmers["ecom-649t93d8snh"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-649t93d8snh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-649t93d8snh', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}